import { render, staticRenderFns } from "./DateSelector.vue?vue&type=template&id=19a8fb37&scoped=true&"
import script from "./DateSelector.vue?vue&type=script&lang=js&"
export * from "./DateSelector.vue?vue&type=script&lang=js&"
import style0 from "./DateSelector.vue?vue&type=style&index=0&id=19a8fb37&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a8fb37",
  null
  
)

export default component.exports